/**
 * 日付の形式を変換する
 * @param {*} date
 */
export function conversionDate(dateStr) {
  var date = new Date(dateStr);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return year + "/" + month + "/" + day;
}

/**
 * str1の文字列からstr2の文字列を除いた文字列を取得する。
 * @param {*} str1
 * @param {*} str2
 */
export function getTargetStr(str1, str2) {
  return str1.replace(str2, "");
}
